<div class="dashboard">

@if (loader()) {
    <div class="loader-wrap">
      <app-spinner-loader [width]="40" />
    </div>
  } @else {
  <!-- Stat Cards -->
  <div class="stats-grid">
    @for (card of statCards; track card.label) {
      <div class="stat-card" [class.gradient]="card.gradient">
        <div class="stat-body">
          <p class="stat-label" [class.white-text]="card.gradient">{{ card.label }}</p>
          <h2 class="stat-value" [class.white-text]="card.gradient">{{ card.value }}</h2>
          <p
            class="stat-change"
            [class.white-text]="card.gradient"
            [class.negative]="!card.positive && !card.gradient">
            {{ card.change }}
          </p>
        </div>
        <div class="stat-icon-wrap" [style.background]="card.iconBg">
          <i class="pi" [ngClass]="card.icon" [style.color]="card.iconColor"></i>
        </div>
      </div>
    }
  </div>

  <!-- Charts Row -->
  <div class="charts-grid">
    <div class="chart-card">
      <div class="chart-header">
        <h3>User Growth</h3>
        <button class="dots-btn" aria-label="More options">···</button>
      </div>
      <div class="chart-wrap">
        <p-chart
          type="line"
          [data]="userGrowthData"
          [options]="userGrowthOptions"
          [style]="{ height: '260px', width: '100%' }">
        </p-chart>
      </div>
    </div>

    <div class="chart-card">
      <div class="chart-header">
        <h3>Engagement</h3>
        <button class="dots-btn" aria-label="More options">···</button>
      </div>
      <div class="chart-wrap">
        <p-chart
          type="bar"
          [data]="engagementData"
          [options]="engagementOptions"
          [style]="{ height: '260px', width: '100%' }">
        </p-chart>
      </div>
    </div>
  </div>

  <!-- Recent Activity -->
  <div class="activity-card">
    <div class="activity-header">
      <h3>Recent Activity</h3>
     <a class="view-all" (click)="toggleViewAll()">
        {{ showAllActivities() ? 'Show Less' : 'View All' }}
      </a>
    </div>
    <div class="activity-list">
      @for (item of visibleActivities(); track item.rawTime) {
        <div class="activity-item">
          <div
            class="act-avatar"
            [style.background]="getActivityIconBg(item.type)"
            [style.color]="getActivityIconColor(item.type)">
            {{ getInitials(item.user.name) }}
          </div>
          <div class="act-content">
            <p class="act-title">{{ item.title }}</p>
            <p class="act-desc">{{ getActivityDescription(item) }}</p>
          </div>
          <div class="act-meta">
            <span class="act-time">{{ item.timestamp }}</span>
            <span class="status-dot"></span>
          </div>
        </div>
      }
    </div>
    </div>
  }

</div>